import Button from 'react-bootstrap/Button';
import { Link, useNavigate } from 'react-router-dom';
import personalBrand from './img/service/personal-brand.webp';
import fotoCitta from './img/service/foto-citta.webp';
import teamInAgenzia from './img/service/team-in-agenzia.webp';
import agenziaImmobiliare from './img/service/agenzia-immobiliare.webp';
import salaPosa from './img/service/sala-posa.webp';
import { useEffect, useState } from 'react';
import axios from 'axios';
import { use } from 'react';

function ServiceCard({
    isSkeleton = false,
    id,
    description,
    image_urls
}) {

    const navigate = useNavigate();

    const handleClick = () => {
        if (isSkeleton || !id) return;
        navigate(`/personal-brand/${id}`);
    };  

    return (
        <li className={isSkeleton ? 'placeholder' : ''}>
            <div className={`card product-card bg-transparent`} onClick={handleClick}>
                <div className="card-body">
                    <img src={image_urls ? image_urls[0].url : ''} className={`image ${isSkeleton ? 'opacity-0' : ''}`} />
                    <h2 className="title">{description}</h2>
                </div>
            </div>
        </li>
    );
}

function ServiceList(props) {

    const [ products, setProducts ] = useState();

    useEffect(() => {
        axios.get('products', {
            params: {
                type: 'GENERIC'
            }
        })
        .then(response => {
            setProducts(response.data);
        });
    }, []);

    return (<>
        <hr className={`mt-2 line-divider ${products && !products.length ? 'd-none' : ''}`} />
        <div className={`section full mt-2 mb-0 ${products && !products.length ? 'd-none' : ''}`}>
            <h2 className="mb-2 ms-2">Eleva il tuo personal brand:</h2>
            <ul id="scroll-service" className="placeholder-glow">
                {!products && Array(5).fill(null).map((_,i) => <ServiceCard key={i} isSkeleton />)}
                {products && products.map(product => (
                    <ServiceCard 
                        key={product.id}
                        {...product}
                    />
                ))}
            </ul>
        </div>
    </>);

}

export default ServiceList;